import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../translations/translations';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('app_language') || 'ru';
  });

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('app_theme') || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('app_language', language);
  }, [language]);

  useEffect(() => {
    localStorage.setItem('app_theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  // Функция перевода
  const t = (key) => {
    if (translations[language] && translations[language][key]) {
      return translations[language][key];
    }
    // Fallback to RU
    return translations['ru'][key] || key;
  };

  // Получить локализованное поле из объекта
  // Например: getLocalizedField(newsItem, 'title') вернет title_ky или title
  const getLocalizedField = (obj, fieldName) => {
    if (!obj) return '';
    if (language === 'ky') {
      const kyField = `${fieldName}_ky`;
      if (obj[kyField]) return obj[kyField];
    }
    return obj[fieldName] || '';
  };

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ru' ? 'ky' : 'ru');
  };

  const value = {
    language,
    theme,
    toggleTheme,
    toggleLanguage,
    setLanguage,
    setTheme,
    t,
    getLocalizedField
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
